// The piece variants' ids — the second axis on `upgrade` (CLAUDE.md, "Piece
// variants").
//
// Shared by both trees and owned by neither — see `board.ts`. An id is a row
// of the engine's `PIECE_VARIANTS` table and a key in the client's model
// registry; what a row *does* stays in `src/engine/rules/rules.ts`, which
// re-exports these.

/** An ordinary piece. Absent from the map means this, so it is never stored. */
export const VARIANT_PLAIN = 0;
/** A pawn that fights. Fodder still. */
export const MARSHAL = 1;
/** Drone-Assisted Miner: a pawn that works the ground. Fodder still. */
export const DAM = 2;
/** A bishop that reaches across the board and cooks nothing. */
export const TURBO_BISHOP = 3;
/** A rook that reaches across the board and mints nothing. */
export const TURBO_ROOK = 4;
/** A queen built to fight: further, harder, thinner, and no factory at all. */
export const JOAN_QUEEN = 5;
/** A queen the Signet Crown made royal and put a foundry in. */
export const MATRIARCH = 6;
/** A bishop that reaches less far, hits twice as hard, and hurries somebody else. */
export const CONFESSOR = 7;
/** A bishop that mends the pieces around it out of the tick it would have cooked in. */
export const MIRACLE_HEALER = 8;
/** A knight that may leap (3,2) as well as (2,1). */
export const PEGASUS = 9;
/** A knight with a horn: it strikes at range and pickets the ground around it. */
export const UNICORN = 10;
/** A knight that goes two diagonal then one orthogonal. */
export const GRYPHON = 11;
/** A knight in plate: it also takes the square beside it, and gives orders. */
export const PALADIN = 12;
// The fuses (§31 P4): rows no `upgrade` sells — two or three bodies become one.
/** Bishop + Rook: a queen's shape at seven, plated, that refines and forges. */
export const DREADNOUGHT = 13;
/** Pegasus + Unicorn + King: a Monarch with every leap, whose horn fires on its move. */
export const ALICORN = 14;
/** Joan-Pattern Queen + Matriarch: Joan's guns, a Monarch, refining and forging. */
export const JOAN_OF_ARC = 15;
